import {
  Directive,
  ElementRef,
  inject,
  OnChanges,
  Renderer2,
  input,
  output
} from '@angular/core';

@Directive({
  selector: '[wcgPaginationShowPage]',
  standalone: false,
})
export class PaginationShowPageDirective implements OnChanges {
  private _elementRef: ElementRef = inject(ElementRef);
  private _ren: Renderer2 = inject(Renderer2);

  readonly pageIndexChangeEmitter = output<number>();
  readonly pageNumberPagination = input.required<number>();
  readonly custPageIndex = input.required<number>();
  private bubbleContainerRef!: HTMLElement;
  private pageInputText!: HTMLElement;

  ngOnChanges(): void {
    this.createPagination();
    this.boxPageEvent();
  }

  private createPagination(): void {
    const actionContainer = this._elementRef.nativeElement.querySelector(
      'div.mat-mdc-paginator-range-actions',
    );
    const nextButtonDefault = this._elementRef.nativeElement.querySelector(
      'button.mat-mdc-paginator-navigation-next',
    );
    if (this.bubbleContainerRef) {
      this._ren.removeChild(actionContainer, this.bubbleContainerRef);
    }

    // create a HTML element to rendered text and input
    this.bubbleContainerRef = this._ren.createElement('div') as HTMLElement;
    this.pageInputText = this._ren.createElement('input') as HTMLElement;
    this._ren.setAttribute(
      this.pageInputText,
      'value',
      this.custPageIndex().toString(),
    );
    const input = this._ren.createText('of ' + this.pageNumberPagination());
    this._ren.setStyle(this.pageInputText, 'width', '20px');
    this._ren.setStyle(this.pageInputText, 'text-align', 'center');
    this._ren.setStyle(this.pageInputText, 'margin-right', '3px');
    this._ren.appendChild(this.bubbleContainerRef, this.pageInputText);
    this._ren.appendChild(this.bubbleContainerRef, input);

    // render element between the 'next button' and 'back button' is displayed
    this._ren.insertBefore(
      actionContainer,
      this.bubbleContainerRef,
      nextButtonDefault,
    );
  }

  private boxPageEvent(): void {
    this._ren.listen(this.pageInputText, 'keyup', () => {
      this.pageIndexChangeEmitter.emit(
        this._elementRef.nativeElement.querySelector('input').value,
      );
    });
  }
}
